import SparkMD5 from 'spark-md5'

// md5加密
export const md5 = (value) => {
  if (value) {
    return SparkMD5.hash(value)
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/md5.js